"use strict";

Object.defineProperty(exports, "__esModule", {
  value: !0
});

var UUID = function () {
  function x() {}

  return x.randomUUID = function () {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (x) {
      var r = 16 * Math.random() | 0;
      return ("x" === x ? r : r % 4 + 8).toString(16);
    });
  }, x;
}();

exports.UUID = UUID;